import { createFileRoute } from '@tanstack/react-router';
import CardPage from '../views/card';

export const Route = createFileRoute('/$uuid/')({
  component: CardPage,
});
